

   //& Show a welcome message at different times of the day :
   export default function getGreeting() {
      const hour = new Date().getHours();
      if (hour >= 5 && hour < 12) {
      return "صباح الخير ☀️";
      } else if (hour >= 12 && hour < 18) {
      return "مساء الخير 🌤";
      } else {
      return "مساء الخير 🌙";
      }
   }